import { render, staticRenderFns } from "./EditAddressStore.vue?vue&type=template&id=377c0840&scoped=true"
import script from "./EditAddressStore.vue?vue&type=script&lang=js"
export * from "./EditAddressStore.vue?vue&type=script&lang=js"
import style0 from "./EditAddressStore.vue?vue&type=style&index=0&id=377c0840&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377c0840",
  null
  
)

export default component.exports